import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { TemplateDesignElement } from '../../design-element';
import {
  CommunicationTemplate,
  CommunicationTemplateViewControl,
  ConfirmationType,
  MassNotificationTemplate,
  MessageSettings
} from 'src/app/modules/communications/store/communications';
import { TemplateDesignerService } from 'src/app/modules/communications/services/template-designer.service';

@Component({
    selector: 'app-tts-notification-message-control',
    templateUrl: './tts-notification-message-control.component.html',
    styleUrls: ['./tts-notification-message-control.component.scss'],
    standalone: false
})
export class TtsNotificationMessageControlComponent implements OnInit, OnDestroy, TemplateDesignElement {
  @Input() index: number = 0;
  @Input() set messageSettings(value: MessageSettings) {
    this._messageSettings = value;
    this.loadData();
  }
  @Input() template?: CommunicationTemplate;
  @Input() control?: CommunicationTemplateViewControl;
  @Input() set culture(value: string) {
    this._culture = value;
    this.loadData();
  }
  _messageSettings: MessageSettings;
  _culture: string;
  @Input() orgLanguages: string[];
  @Input() selected: boolean;
  @Output() settingsChanged = new EventEmitter<{ uId: string; settings: any }>();

  editMode: boolean;
  messageText: string;
  confirmationButtons: { type: ConfirmationType; text: string }[];

  constructor(private templateDesignerService: TemplateDesignerService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  loadSettings(): void {
    this.editMode = true;
    this.loadData();
  }

  saveSettings(): boolean {
    return true;
  }

  render(): void {
    this.editMode = false;
    this.loadData();
  }

  private loadData() {
    this.messageText = this.templateDesignerService.getTranslateText(this._messageSettings?.notificationMessage, this._culture);
  }

  edit(): void {}

  setRuntimeData(data: any): void {}
}
